<template>
  <div class="view-search container-fluid">
    <h5 class="search-title mb-0">
      Resultados para: <em>"</em>{{ $route.query.search }}<em>"</em>
    </h5>

    <p class="results-count d-block my-0 pt-0 pb-5">
      <template v-if="lessons.length === 0">Nenhum resultado</template>
      <template v-else>{{ all_count }} resultados</template>
    </p>

    <action-dispatcher
      action="lessons/search"
      :parameters="params"
      @success="successLessons"
    >
      <h5 class="page-title my-3">Aulas</h5>

      <lessons-quiz-list v-if="lessons.length" :items="lessons" />
      <p v-else class="text-secondary">
        Não encontramos aulas para: <em>"</em>{{ $route.query.search
        }}<em>"</em>
      </p>
    </action-dispatcher>

    <action-dispatcher
      action="modules/search"
      :parameters="params"
      @success="successModules"
    >
      <h5 class="page-title my-3">Módulos</h5>
      <p v-if="!modules.length" class="text-secondary">
        Não encontramos módulos para: <em>"</em>{{ $route.query.search
        }}<em>"</em>
      </p>
      <template v-else>
        <home-carousel :list="modules">
          <template #default="{ data }">
            <module-card class="flex-fill" :module="data" />
          </template>
        </home-carousel>
      </template>
    </action-dispatcher>

    <action-dispatcher
      action="modules/submodule_search"
      :parameters="params"
      @success="successSubmodules"
    >
      <h5 class="page-title my-3">Submódulos</h5>
      <p v-if="!submodules.length" class="text-secondary">
        Não encontramos submódulos para: <em>"</em>{{ $route.query.search
        }}<em>"</em>
      </p>
      <template v-else>
        <home-carousel :list="submodules">
          <template #default="{ data }">
            <module-card class="flex-fill" :module="data" />
          </template>
        </home-carousel>
      </template>
    </action-dispatcher>

    <!-- <pagination class="mt-5" v-model="params" :count="count" /> -->
  </div>
</template>

<script>
import LessonsQuizList from "@/components/module/LessonsQuizList";
import HomeCarousel from "@/components/home/HomeCarousel";
import ModuleCard from "@/components/home/ModuleCard";

export default {
  components: { HomeCarousel, ModuleCard, LessonsQuizList },
  computed: {
    all_count() {
      return Number(
        this.modules.length + this.submodules.length + this.lessons.length
      );
    },
    params() {
      const limit = 6;
      return {
        ...this.$route.query,
        limit,
        offset: limit * (parseInt(this.$route.query.page) - 1) || 0
      };
    }
  },
  data() {
    return { submodules: [], lessons: [], modules: [] };
  },
  methods: {
    successSubmodules(data) {
      this.submodules = data.results;
    },
    successModules(data) {
      this.modules = data.results;
    },
    successLessons(data) {
      this.lessons = data.results;
    }
  }
};
</script>

<style lang="scss" scoped>
.view-search {
  padding-top: 72px;

  .search-title {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  .results-count {
    font-family: "Noto Sans", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
}
</style>
